import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type ScrollOptions = {
  target?: 'window' | 'dialog';
  dependency?: any;
};

export const useScrollToTop = ({ target = 'window', dependency }: ScrollOptions = {}) => {
  const location = useLocation();

  useEffect(() => {
    if (target === 'dialog') {
      const dialogContent = document.querySelector('.MuiDialogContent-root');
      if (dialogContent) {
        dialogContent.scrollTop = 0;
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [dependency, location.pathname, target]);
}; 